import { defineMessages } from 'react-intl';

const messages = defineMessages({
  menu: {
    id: 'bfcf1d2a0c4be80a6011518767e50c1d7660b8b30b91948e4a7b651565b11df4',
    defaultMessage: 'Menu',
    description: 'Button to open the menu.',
  },
  decline: {
    id: 'c9418f47125e581cc8d40561b46e6cfbcfa3ca788f2335c5b07bdf19cc55d826',
    defaultMessage: 'Decline',
    description: 'Button to decline signing the document.',
  },
  declineSubtitle: {
    id: 'd2373705aaca6734a1bf8fdb39b4dce8f5c6e85d4f118d57681fe8365393b9d0',
    defaultMessage: 'Decline to sign this document.',
    description: 'Button to decline signing the document.',
  },
  download: {
    id: '030347be46c81f891344210e68dae1b72623def2394d8aab399685714e2332a8',
    defaultMessage: 'Download',
    description: 'Button to download the document.',
  },
  downloadSubtitle: {
    id: 'c1b1a33384e00ce566bf21bb857bf838bd0b9be90fbef559772ead0fe3d96362',
    defaultMessage: 'Download the document.',
    description: 'Button to download the document.',
  },
  requiredFields: {
    id: 'dbf89df132e0bb4e7c80d8dffa46b71e5e1110c288d05d839b071ec5d6fed147',
    description: 'Tells the user how many required fields need to be filled',
    defaultMessage:
      '{requiredFields, plural, =1 {1 required field} other {# required fields}}',
  },
  requiredFieldsAndAttachments: {
    id: '037081d01fbb36c805ace51962208a942b92c3f439999b6020932648e3a7058a',
    description:
      'Tells the user how many required fields and attachments need to be filled',
    defaultMessage:
      '{requiredFieldsLeft, plural, =1 {1 required field} other {# required fields}} and {requiredAttachmentsLeft, plural, =1 {1 required attachment} other {# required attachments}}',
  },
  requiredFieldsLeft: {
    id: '5e2474ca62d0a808fe9f3746f211751d152359d5350881add110a9fec4733fc9',
    description:
      'Tells the user how many required fields are left to be filled',
    defaultMessage:
      '{requiredFields, plural, =1 {1 required field} other {# required fields}} left',
  },
  requiredFieldsAndAttachmentsLeft: {
    id: '5c69df6570dafb458a48698ac6815c1a09b7dd1fdd563d6c8d52d8e597b730b6',
    description:
      'Tells the user how many required fields and attachments are left to be filled',
    defaultMessage:
      '{requiredFieldsLeft, plural, =1 {1 field} other {# fields}} & {requiredAttachmentsLeft, plural, =1 {1 attachment} other {# attachments}} required left',
  },
  poweredByDropbox: {
    id: '74b8edf8a457e30f1b0f9b3f851ad192d1a0fa67c09a4dd15acc48a646a51864',
    description: 'Powered by Dropbox alt text',
    // eslint-disable-next-line no-restricted-syntax
    defaultMessage: 'Powered by Dropbox Sign',
  },
  brandLogo: {
    id: '8e4d92a5d65a81929b6c49bc535bf2320f8bc89fbc5a35a6a736a113c6c7faaa',
    description: 'Brand logo alt text',
    defaultMessage: 'Brand logo',
  },
  prevButton: {
    id: 'df3ec8a33aebc1e14a158b75fc9c008a4964c33a9ac72c4bcf7999e4856bb018',
    description:
      'Previous button, signers can use this to navigate to the previous field',
    defaultMessage: 'Previous',
  },
});

export default messages;
